import { View } from "@-/com.npmjs.react-native";
import type { ReactNode } from "react";

/** Fading answers and Continue must not accept invisible touches or screen-reader actions. */
export function OnboardingQuestionInputGate({
  children,
  isReady,
}: {
  children: ReactNode;
  isReady: boolean;
}) {
  return (
    <View
      accessibilityElementsHidden={!isReady}
      className="flex-1"
      importantForAccessibility={isReady ? "auto" : "no-hide-descendants"}
      pointerEvents={isReady ? "auto" : "none"}
      testID="onboarding-question-input-gate"
    >
      {children}
    </View>
  );
}
